const getCheckedBoxValuesByName = (cbName) => {
  const checkboxes = document.getElementsByName(cbName);
  let checkboxesChecked = [];
  for (let i = 0; i < checkboxes.length; i++) {
    if (checkboxes[i].checked) {
      checkboxesChecked.push(checkboxes[i].value);
    }
  }
  // Return the array if it is non-empty, or null
  return checkboxesChecked.length > 0 ? checkboxesChecked : null;
}

export default getCheckedBoxValuesByName;
